import React, {useEffect, useMemo, useState} from 'react';
import {Route, NavLink, Redirect, Link} from 'react-router-dom';
import DetailVocabulary from './DetailVocabulary';
import DetailGrammar from './DetailGrammar';
import DetailPhonetics from './DetailPhonetics';
import {QUERY_LESSON_DETAIL} from './graphql';
import {useMutation, useQuery} from '@apollo/client';
import Query, {Loading} from '../../components/Query';
import {MUTATION_STUDY_PASS_LESSON, QUERY_STUDY_LIST} from '../Study/graphql';
import TaskList from '../Task/List';
import Back from '../../components/Back';
import Icon from '../../components/Icon';
import {QUERY_USER} from '../Client/graphql';
import {isActive, isLimited} from '../Client/utils';
import {locale} from "../../utils/joyride";
import Joyride, { ACTIONS, EVENTS, ORIGIN, STATUS } from 'react-joyride';


const Lesson = ({match}) => {
  const [isPass, setIsPass] = useState(false);
  const [showInfo, setShowInfo] = useState(!localStorage.getItem('alertedLessonDetail@quiz-client'));
  const [showVocabularyInfo, setShowVocabularyInfo] = useState(
    !localStorage.getItem('alertedLessonDetail1@quiz-client'),
  );
  const [showGrammarInfo, setShowGrammarInfo] = useState(!localStorage.getItem('alertedLessonDetail2@quiz-client'));
  const [showPhoneticsInfo, setShowPhoneticsInfo] = useState(!localStorage.getItem('alertedLessonDetail3@quiz-client'));
  
  const [run, setRun] = useState(false);
  const [nextRun, setNextRun] = useState(null);
  const [steps, setSteps] = useState([]);
  const [stepIndex, setStepIndex] = useState(0);

  const {user} = useQuery(QUERY_USER).data;

  const query = useQuery(QUERY_LESSON_DETAIL, {variables: {id: match.params.id}});
  const data = query.data ? query.data.lessonDetail : null;

  // useEffect(() => {
  //   if (data) {
  //     setRun(true);
  //   }
  // }, [data]);

  const studyQuery = useQuery(QUERY_STUDY_LIST);
  const {data: {studyList = []} = {}} = studyQuery;
  const study = useMemo(() => (studyList.find(x => x.lessonId === match.params.id)), [studyList]);

  useEffect(() => {
    if (!localStorage.getItem('tourFinished@quiz-client') && study && data && data.level === 0) {
      if (!study.phoneticsPassed) {
        setSteps([
          {
            target: '.nav.nav-tabs',
            content: 'Каждый урок состоит из трех частей: Лексика, Грамматика и Фонетика',
            disableBeacon: true,
          },
          {
            target: '.nav-item.phonetics',
            content: 'Нажмите на вкладку Фонетика',
            disableBeacon: true,
          }
        ]);
        setStepIndex(0);
        setTimeout(() => {
          setRun(true);
        }, 300);
      }
      else if (!study.vocabularyPassed) {
        setSteps([
          {
            target: '.nav-item.phonetics',
            content: 'Рядом с Фонетикой появилась зеленая галочка, это означает, что данный элемент урока пройден',
            disableBeacon: true,
          },
          {
            target: '.nav-item.vocabluary',
            content: 'Теперь нажмите на вкладку Лексика',
            disableBeacon: true,
          }
        ]);
        setStepIndex(0);
        setTimeout(() => {
          setRun(true);
        }, 300);
      } 
      else if (!study.finalPassed && nextRun !== 'grammar') {
        setSteps([
          {
            target: '.nav-item.vocabluary',
            content: 'Как видите здесь тоже появилась зеленая галочка',
            disableBeacon: true,
          },
          {
            target: '.nav-item.grammar',
            content: 'Теперь переходим к Грамматике',
            disableBeacon: true,
          }
        ]);
        setStepIndex(0);
        setTimeout(() => {
          setRun(true);
        }, 300);
      } 
      else if (study.phoneticsPassed && study.vocabularyPassed && study.trialPassed && study.finalPassed) {
        setSteps([
          {
            target: '.nav.nav-tabs',
            content: 'Все три элемента урока пройдены',
            disableBeacon: true,
          },
          {
            target: '.btn-back',
            content: 'Нажмите на "Вернуться назад"',
            disableBeacon: true,
          }
        ]);
        setStepIndex(0);
        setTimeout(() => {
          setRun(true);
        }, 300);
      }
    }
  }, [study, data]);

  const [pass] = useMutation(MUTATION_STUDY_PASS_LESSON, {
    onCompleted: data => {
      if (data.studyPassLesson.obj) {
        studyQuery.refetch();
      }
    },
  });

  if (query.loading) return <Loading />;

  if (!isActive(user) && data.level > 10) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center">
        <div className="font-4 mb-4">Сейчас вам доступно 10 уроков, после активации будут доступны все 75</div>
      </div>
    );
  }

  const handleJoyrideCallback = data => {
    const { action, index, origin, status, type } = data;

    if (action === ACTIONS.CLOSE && origin === ORIGIN.KEYBOARD) {
      // do something
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      const nextStep = index + (action === ACTIONS.PREV ? -1 : 1);
      setStepIndex(nextStep);
      if (!study.phoneticsPassed && nextStep === 2) {
        setNextRun('phonetics');
      } else if(!study.vocabularyPassed && nextStep === 2) {
        setNextRun('vocabulary');
      } else if(!study.finalPassed && nextStep === 2) {
        setNextRun('grammar');
      }
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // You need to set our running state to false, so we can restart if we click start again.
      setRun(false);
    }

    // console.groupCollapsed(type);
    // console.log(data); //eslint-disable-line no-console
    // console.groupEnd();
  };

  return (
    <div className="py-4">
      {study && (
          <Joyride 
            run={run} 
            steps={steps} 
            stepIndex={stepIndex} 
            locale={locale} 
            callback={handleJoyrideCallback}
            scrollOffset={80}
          />
      )}
      {!isActive(user) && (
        <div className="alert alert-warning p-3 mt-4 mb-4">
          <div className="row justify-content-center align-items-center">
            <div className="col-auto text-center ms-1">
              {user.client.activeTill ? 'Активация вашего аккаунта просрочена.' : ''} Первые 10 уроков пробные. Для их
              прохождения активация не требуется
            </div>
            <div className="col-auto">
              <Link to="/payments" className="btn btn-link p-0 ms-2">
                Активировать
              </Link>
            </div>
          </div>
        </div>
      )}
      {/* {showInfo && (
        <div className="alert alert-info text-center">
          <div>
            Каждый урок состоит из трех элементов: Лексика, Грамматика и Фонетика
            <br />
            Для прохождения урока нужно пройти все три элемента
            <br />
            После прохождения элемента появится зеленая галочка
          </div>
          <button
            onClick={() => {
              localStorage.setItem('alertedLessonDetail@quiz-client', true);
              setShowInfo(false);
            }}
            type="button"
            className="btn btn-light btn-sm mt-2"
          >
            <span>Закрыть</span>
          </button>
        </div>
      )} */}
      <div className="row gx-lg-3 gy-3 align-items-center mb-3">
        <div className="col-lg-auto">
          <Back />
        </div>
        {data && <div className="col-lg-auto font-4 fw-bold">{'Урок ' + data.level + '. ' + data.name}</div>}
        <div className="col-lg-auto">
          <div className="row gx-2">
            {[...Array(data.importance)].map(x => (
              <div key={x} className="col-auto">
                <Icon
                  name="star"
                  color={
                    data.importance > 4
                      ? 'success'
                      : data.importance > 3
                      ? 'warning'
                      : data.importance > 2
                      ? 'orange'
                      : 'danger'
                  }
                />
              </div>
            ))}
          </div>
        </div>
        {/* {study &&
          data.level === user.client.currentLevel &&
          !user.client.isRepeat &&
          (isActive(user) || (!isActive(user) && data.level <= 10)) &&
          (isPass ? (
            <div>
              <div className="text-end">Вы не прошли задания, вы точно хотите пропустить урок?</div>
              <div className="row justify-content-center mt-2">
                <div className="col-auto ms-auto">
                  <button onClick={() => pass({variables: {input: {id: study.id}}})} className="btn btn-primary">
                    Пропустить
                  </button>
                </div>
                <div className="col-auto ms-2">
                  <button onClick={() => setIsPass(false)} className="btn btn-secondary">
                    Отмена
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-auto ms-auto">
              <button onClick={() => setIsPass(true)} className="btn btn-secondary">
                Пропустить урок
              </button>
            </div>
          ))} */}
      </div>
      {Query(query) ||
      (data.level === user.client.currentLevel && study && study.intermediatePassed === null && isLimited(user)) ? (
        <div>
          <div className="row font-4">
            <div className="col-auto">У вас превышен лимит за по скрости обучения. </div>
            <div className="col-auto ms-2">
              <Link to="/settings">Настроить.</Link>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <ul className="nav nav-tabs justify-content-center align-items-end">
            <li className="nav-item vocabluary">
              <NavLink replace to={`${match.url}/vocabulary`} className="nav-link px-1 px-md-3 text-dark">
                <div className="row align-items-center gx-1 gx-md-2 font-4">
                  <div className="col-auto">Лексика</div>
                  <div className="col-auto">
                    <Icon
                      name={study && study.vocabularyPassed ? 'check' : 'dot-circle'}
                      color={study && study.vocabularyPassed ? 'success' : 'primary'}
                    />
                  </div>
                </div>
              </NavLink>
            </li>
            <li className="nav-item grammar">
              <NavLink replace to={`${match.url}/grammar`} className="nav-link px-1 px-md-3 text-dark">
                <div className="row align-items-center gx-1 gx-md-2 font-5">
                  <div className="col-auto">Грамматика</div>
                  <div className="col-auto">
                    <Icon
                      name={study && study.finalPassed ? 'check' : 'dot-circle'}
                      color={study && study.finalPassed ? 'success' : 'primary'}
                    />
                  </div>
                </div>
              </NavLink>
            </li>
            {data.vocabularyContent && (
              <li className="nav-item phonetics">
                <NavLink replace to={`${match.url}/phonetics`} className="nav-link px-1 px-md-3 text-dark">
                  <div className="row align-items-center gx-1 gx-md-2 font-4">
                    <div className="col-auto">Фонетика</div>
                    <div className="col-auto">
                      <Icon
                        name={study && study.phoneticsPassed ? 'check' : 'dot-circle'}
                        color={study && study.phoneticsPassed ? 'success' : 'primary'}
                      />
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
          </ul>
          <div className="bg-white p-3 p-lg-4 border border-top-0">
            {/*<Redirect exact path={match.url} to={`${match.url}/grammar`} />*/}
            <Route path={`${match.url}/vocabulary`} exact>
              {/* {!showInfo && showVocabularyInfo && (
                <div className="alert alert-info text-center">
                  <div>
                    В Лексике будут самые распространенные слова
                    <br />
                    Можно послушать произношение. После пройдите тест
                  </div>
                  <button
                    onClick={() => {
                      localStorage.setItem('alertedLessonDetail1@quiz-client', true);
                      setShowVocabularyInfo(false);
                    }}
                    type="button"
                    className="btn btn-light btn-sm mt-2"
                  >
                    <span>Закрыть</span>
                  </button>
                </div>
              )} */}
              <DetailVocabulary
                nextRun={nextRun}
                study={study}
                lesson={data}
                passed={study && study.vocabularyPassed}
                id={match.params.id}
                content={data.vocabularyContent}
              />
            </Route>
            <Route path={`${match.url}/vocabulary/test/`} exact>
              <TaskList study={study} lesson={data} kind="VOCABULARY" nextRun={nextRun} />
            </Route>
            <Route path={`${match.url}/grammar`} exact>
              {/* {!showInfo && showGrammarInfo && (
                <div className="alert alert-info text-center">
                  <div>
                    Изучите тему грамматики
                    <br />
                    Материал дан в краткой и легкой форме
                    <br />
                    Затем пройдите практическое занятие и финальный тест
                  </div>
                  <button
                    onClick={() => {
                      localStorage.setItem('alertedLessonDetail2@quiz-client', true);
                      setShowGrammarInfo(false);
                    }}
                    type="button"
                    className="btn btn-light btn-sm mt-2"
                  >
                    <span>Закрыть</span>
                  </button>
                </div>
              )} */}
              <DetailGrammar
                nextRun={nextRun}
                study={study}
                trialPassed={study && study.trialPassed}
                passed={study && study.finalPassed}
                intermediatePassed={study && study.intermediatePassed}
                id={match.params.id}
                content={data.grammarContent}
              />
            </Route>
            <Route path={`${match.url}/grammar/test`} exact>
              <TaskList study={study} lesson={data} kind="TRIAL" nextRun={nextRun} />
            </Route>
            <Route path={`${match.url}/grammar/final-test`} exact>
              <TaskList study={study} lesson={data} kind="FINAL" nextRun={nextRun} />
            </Route>
            <Route path={`${match.url}/phonetics`} exact>
              {/* {!showInfo && showPhoneticsInfo && (
                <div className="alert alert-info text-center">
                  <div>
                    В Фонетике мы будем знакомиться с особенностями произношения
                    <br />
                    После нажмите &quot;завершить чтение&quot;
                  </div>
                  <button
                    onClick={() => {
                      localStorage.setItem('alertedLessonDetail3@quiz-client', true);
                      setShowPhoneticsInfo(false);
                    }}
                    type="button"
                    className="btn btn-light btn-sm mt-2"
                  >
                    <span>Закрыть</span>
                  </button>
                </div>
              )} */}
              <DetailPhonetics
                nextRun={nextRun}
                lesson={data}
                study={study}
                lessonId={match.params.id}
                content={data.phoneticsContent}
              />
            </Route>
          </div>
        </div>
      )}
    </div>
  );
};

export default Lesson;
